<template>
  <Bv627Home />
</template>

<script setup>
import Bv627Home from "@/components/easteregg/bv627.vue";
</script>

